import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import router from './router'
import ListUsersComponent from './components/ListUsersComponent.vue'
import LoginComponent from './components/LoginComponent.vue'
import TopBarComponent from './components/TopBarComponent.vue'
import DragAndDropComponent from './components/DragAndDropComponent.vue'
import ImportExportComponent from './components/ImportExportComponent.vue'

loadFonts()

const app = createApp(App)
app.use(router).use(vuetify).mount('#app')

app.component('ListUsersComponent', ListUsersComponent)
app.component('LoginComponent', LoginComponent)
app.component('TopBarComponent', TopBarComponent)
app.component('DragAndDropComponent', DragAndDropComponent)
app.component('ImportExportComponent', ImportExportComponent)
